export enum ConciergeServiceType {
  ConciergeRequest = "ConciergeRequest",
  ConciergeEvent = "ConciergeEvent",
  ConciergeProduct = "ConciergeProduct",
}
